import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from "../../../models/utilities/document-request";
import { API_METHODS } from "../../../models/utilities/type-models";
import { ApiEndpoints } from "../../../utils/app-constants";
import { AppUtils } from "../../../utils/app-utils";
import { CustomerServiceSearchFilters } from "./customer-service-search-filters";

export class DocumentCustomerServiceQueryExport implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'xlsx';
    public openInTab : boolean = false;
    public url : string = '';
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'GET';

    constructor(filters: CustomerServiceSearchFilters) {
        this.url = AppUtils.convertFiltersToUrl(ApiEndpoints.ORDERING_CUSTOMER_SERVICE_REVIEW_EXPORT, filters);
        this.filename = 'Customer_Service_Export';
    }
}
